// src/components/ScrollToTop.js
import React, { useState, useEffect } from "react";
import { ActionIcon } from "@mantine/core";
import { IconArrowUp } from "@tabler/icons-react";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <ActionIcon
      size="lg"
      radius="xl"
      variant="filled"
      color="blue"
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        display: isVisible ? "inline" : "none",
      }}
      onClick={scrollToTop}
    >
      <IconArrowUp size={24} />
    </ActionIcon>
  );
};

export default ScrollToTop;
